import { render, staticRenderFns } from "./NationalIdSkeleton.vue?vue&type=template&id=4e015eee&scoped=true&"
import script from "./NationalIdSkeleton.vue?vue&type=script&lang=ts&"
export * from "./NationalIdSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./NationalIdSkeleton.vue?vue&type=style&index=0&id=4e015eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e015eee",
  null
  
)

export default component.exports